import { render, staticRenderFns } from "./ListCard.vue?vue&type=template&id=22a45870&scoped=true"
import script from "./ListCard.vue?vue&type=script&lang=js"
export * from "./ListCard.vue?vue&type=script&lang=js"
import style0 from "./ListCard.vue?vue&type=style&index=0&id=22a45870&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a45870",
  null
  
)

export default component.exports